import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import Text from "../../common/Text";
import { Link } from "react-router-dom";
import { websiteLink } from "../../../helpers/helpers";
import { useSelector } from "react-redux";
import paths from "../../../constants/paths";

const SubscriptionPlanNew = ({
  data,
  content,
  plans,
  monthly_plans,
  annual_plans,
  offers,
  subscribed_id,
  is_cancelled,
  subscRef,
  offers_text,
}) => {
  const [open, setOpen] = useState(null);
  const [isAnnual, setIsAnnual] = useState(true);
  const [syncedHeight, setSyncedHeight] = useState(null);

  const activePlans = isAnnual ? annual_plans : monthly_plans;
  const authToken = useSelector((state) => state.fetchSignin.authToken);

  // Ref for measuring height of expanded offer
  const expandedRef = useRef(null);

  useEffect(() => {
    if (expandedRef.current && open) {
      setSyncedHeight(expandedRef.current.scrollHeight);
    } else {
      setSyncedHeight(null);
    }
  }, [open]);

  const togglePricing = () => {
    setIsAnnual(!isAnnual);
  };

  useEffect(() => {
    if (!subscribed_id || !annual_plans || !monthly_plans) return;

    const id = Number(subscribed_id);

    if (id === 3) {
      setIsAnnual(true);
    } else if (id === 1) {
      setIsAnnual(false);
    } else if (annual_plans.some((plan) => Number(plan.id) === id)) {
      setIsAnnual(true);
    } else if (monthly_plans.some((plan) => Number(plan.id) === id)) {
      setIsAnnual(false);
    }
  }, [subscribed_id, annual_plans, monthly_plans]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);

  useLayoutEffect(() => {
    const rows = document.querySelectorAll(".plan_flex .col");
    if (!rows.length) return;

    const firstColItems = rows[0].querySelectorAll("li").length;

    for (let i = 0; i < firstColItems; i++) {
      let maxHeight = 0;

      rows.forEach((col) => {
        const li = col.querySelectorAll("li")[i];
        if (li) {
          li.style.height = "auto";
          maxHeight = Math.max(maxHeight, li.offsetHeight);
        }
      });

      rows.forEach((col) => {
        const li = col.querySelectorAll("li")[i];
        if (li) {
          li.style.height = maxHeight + "px";
        }
      });
    }
  }, [activePlans, offers, isAnnual]);

  const handleSelectPlan = (plan) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "select_plan",
        plan: {
          // Add monthly/biannual info to plan name
          name: `${plan.plan_name} (${isAnnual ? "Biannually" : "Monthly"})`,
          price: isAnnual ? plan.price_per_month * 6 : plan.price_per_month,
          currency: "GBP",
        },
      });
    }
  };

  return (
    <>
      <section id="subscription">
        <div className="contain">
          <div className="text-center sub_scription_heading">
            <h2>
              <Text string={content.banner_heading} />
            </h2>
            <p>
              <Text string={content.banner_tagline} />
            </p>
          </div>
          <div className="pricing-container">
            <div className="toggle-wrapper">
              <span className={!isAnnual ? "active-label" : ""}>Monthly</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isAnnual}
                  onChange={togglePricing}
                />
                <span className="slider"></span>
              </label>
              <span
                className={`d-flex align-items-center gap-3 ${isAnnual ? "active-label" : ""}`}
              >
                Biannually <em className="featured_job_new2">30% off</em>
              </span>
            </div>
          </div>

          <div className="flex plan_flex cstm_plan_new_ofer">
            {/* First Column (Offers) */}
            <div className="col">
              <ul className="title_sub_lst">
                <li>
                  <h4>
                    <Text string={content.plans_heading} />
                  </h4>
                  <p>
                    <Text string={content.plan_tagline} />
                  </p>
                </li>
                {offers &&
                  offers.map((offer) => {
                    const hasDetails =
                      offer?.details && offer.details.trim() !== "";
                    const isOpen = open === offer.id;

                    return (
                      <li
                        key={offer.id}
                        ref={isOpen ? expandedRef : null}
                        className={
                          hasDetails
                            ? isOpen
                              ? "drop_title_subscription open"
                              : "drop_title_subscription"
                            : ""
                        }
                      >
                        <div className="title_plan_new new_toolTip">
                          {offer.title}
                        </div>
                        <div className="cntnt_drop">
                          <Text string={offer.details} parse={true} />
                        </div>
                      </li>
                    );
                  })}

                <li>
                  {/* <div className="mini_lbl">
                    <span>
                      <Text string={content.cancel_heading} />
                    </span>
                    <Text string={content.cancel_tagline} />
                  </div> */}
                </li>
              </ul>
            </div>

            {/* Plans Columns */}
            {activePlans && activePlans.length > 0 ? (
              activePlans.map((plan) => (
                <div className="col" key={plan.id}>
                  <ul className="title_sub_lst">
                    <li>
                      {plan.is_popular == 1 && (
                        <div className="top_most">
                          <p>Most Popular</p>
                        </div>
                      )}
                      {plan.price_per_month > 0 ? (
                        <>
                          <h6>{plan.plan_name}</h6>
                          <h4 className="color">
                            £{plan.price_per_month}
                            <small>/month</small>
                          </h4>
                        </>
                      ) : (
                        <h4 className="color">{plan.plan_name}</h4>
                      )}
                      <p>{plan.tagline}</p>
                    </li>

                    {offers &&
                      offers.map((offer) => {
                        const selected = plan.selected_offers.find(
                          (o) => o.offer_id === offer.id,
                        );

                        return (
                          <li key={offer.id}>
                            {selected ? (
                              <div className="green_check_img">
                                <span>
                                  {offer.title}
                                  {offer.details && (
                                    <div className="tooltip">
                                      <img
                                        src={
                                          paths.SITE_BASE_URL +
                                          "/images/info-circle.svg"
                                        }
                                        alt=""
                                        className="tool_icon"
                                      />
                                      <span className="tooltipText">
                                        <Text
                                          string={offer.details}
                                          parse={true}
                                        />
                                      </span>
                                    </div>
                                  )}
                                </span>
                                {!selected.extra_text && (
                                  <img
                                    src="images/new/tick-circle.svg"
                                    alt=""
                                  />
                                )}
                                {selected.extra_text && (
                                  <div className="text_mini">
                                    <p>{selected.extra_text}</p>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="gray_check_img">
                                <span>
                                  {offer.title}
                                  {offer.details && (
                                    <div className="tooltip">
                                      <img
                                        src={
                                          paths.SITE_BASE_URL +
                                          "/images/info-circle.svg"
                                        }
                                        alt=""
                                        className="tool_icon"
                                      />
                                      <span className="tooltipText">
                                        <Text
                                          string={offer.details}
                                          parse={true}
                                        />
                                      </span>
                                    </div>
                                  )}
                                </span>
                                <img src="images/new/close-circle.svg" alt="" />
                              </div>
                            )}
                          </li>
                        );
                      })}

                    <li>
                      <div className="btn_blk">
                        {subscribed_id > 0 ? (
                          is_cancelled ? (
                            subscribed_id == plan.id ? (
                              <Link
                                to={websiteLink(
                                  `/subscription-payment/${plan.encoded_id}`,
                                )}
                                className="site_btn blank"
                              >
                                Current Plan
                              </Link>
                            ) : plan.id == 4 || plan.id == 9 ? (
                              <Link to="#" className="site_btn">
                                Select Plan
                              </Link>
                            ) : (
                              <Link
                                to={websiteLink(
                                  `/subscription-payment/${plan.encoded_id}`,
                                )}
                                className="site_btn"
                                onClick={() => handleSelectPlan(plan)}
                              >
                                Select Plan
                              </Link>
                            )
                          ) : subscribed_id == 2 ? (
                            plan.id == 4 || plan.id == 9 ? (
                              <Link to="#" className="site_btn">
                                Select Plan
                              </Link>
                            ) : (
                              <Link
                                to={websiteLink(
                                  `/subscription-payment/${plan.encoded_id}`,
                                )}
                                className="site_btn"
                                onClick={() => handleSelectPlan(plan)}
                              >
                                Select Plan
                              </Link>
                            )
                          ) : (
                            <Link
                              to={
                                subscribed_id == plan.id ||
                                (subscribed_id == 1 &&
                                  plan.id ===
                                    (monthly_plans?.[1]?.id || null)) ||
                                (subscribed_id == 3 &&
                                  plan.id === (annual_plans?.[1]?.id || null))
                                  ? "#"
                                  : "#"
                              }
                              className={
                                subscribed_id == plan.id ||
                                (subscribed_id == 1 &&
                                  plan.id ===
                                    (monthly_plans?.[1]?.id || null)) ||
                                (subscribed_id == 3 &&
                                  plan.id === (annual_plans?.[1]?.id || null))
                                  ? "site_btn blank"
                                  : "site_btn"
                              }
                            >
                              {subscribed_id == plan.id ||
                              (subscribed_id == 1 &&
                                plan.id === (monthly_plans?.[1]?.id || null)) ||
                              (subscribed_id == 3 &&
                                plan.id === (annual_plans?.[1]?.id || null))
                                ? "Current Plan"
                                : "Select Plan"}
                            </Link>
                          )
                        ) : (plan.id == 4 || plan.id == 9) && authToken ? (
                          <Link to="#" className="site_btn blank">
                            Current Plan
                          </Link>
                        ) : (
                          <Link
                            to={websiteLink(
                              `/subscription-payment/${plan.encoded_id}`,
                            )}
                            className="site_btn"
                            onClick={() => handleSelectPlan(plan)}
                          >
                            Select Plan
                          </Link>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              ))
            ) : (
              <div className="no-plans-message">
                <p>
                  {isAnnual
                    ? "No Annual Plans Available"
                    : "No Monthly Plans Available"}
                </p>
              </div>
            )}

            {/* {isAnnual ? (
              <>
                <div className="col">
                  <ul className="title_sub_lst">
                    <li>
                      <h4 className="color">Free</h4>
                    </li>
                    <li>
                      <div className="gray_check_img">
                        <span>Visa-sponsored Jobs</span>
                        <div className="text_mini">
                          <p>30 jobs (first 2 pages)</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Community</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>CV Review</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Priority Support</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa Guidance</span>
                        <div className="text_mini">
                          <p>Basic</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Interview Prep</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Employer Network</span>
                        <div className="text_mini">
                          <p>Limited</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Success Rate</span>
                        <div className="text_mini">
                          <p>45%</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Monthly Webinars</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Job Applications</span>
                        <div className="text_mini">
                          <p>10</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Money-back Guarantee</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="btn_blk">
                        <a className="site_btn blank" href="/subscription">
                          Current Plan
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="col">
                  <ul className="title_sub_lst">
                    <li>
                      <h6>Explore</h6>
                      <h4 className="color">
                        £3.99 <small>/month</small>
                      </h4>
                      <p>Billed every 6 months for £23.94. Cancel anytime.</p>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa-sponsored Jobs</span>
                        <div className="text_mini">
                          <p>All</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Community</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>CV Review</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                          <p>Unlimited</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Priority Support</span>
                        <div className="text_mini">
                          <p>24/7</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa Guidance</span>
                        <div className="text_mini">
                          <p>Expert</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Interview Prep</span>
                        <div className="text_mini">
                          <p>1-on-1</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Employer Network</span>
                        <div className="text_mini">
                          <p>VIP Access</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Success Rate</span>
                        <div className="text_mini">
                          <p>90%</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Monthly Webinars</span>
                        <div className="text_mini">
                          <p>Weekly</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Job Applications</span>
                        <div className="text_mini">
                          <p>Unlimited</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Money-back Guarantee</span>
                        <div className="text_mini">
                          <p>60 days</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="btn_blk">
                        <a className="site_btn" href="/subscription">
                          Select Plan
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="col">
                  <div className="top_most">
                    <p>Most Popular</p>
                  </div>
                  <ul className="title_sub_lst">
                    <li>
                      <h6>Achieve</h6>
                      <h4 className="color">
                        £6.49 <small>/month</small>
                      </h4>
                      <p>Billed every 6 months for £38.94. Cancel anytime.</p>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa-sponsored Jobs</span>
                        <div className="text_mini">
                          <p>All</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Community</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>CV Review</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Priority Support</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa Guidance</span>
                        <div className="text_mini">
                          <p>Premium</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Interview Prep</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Employer Network</span>
                        <div className="text_mini">
                          <p>Full Access</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Success Rate</span>
                        <div className="text_mini">
                          <p>75%</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Monthly Webinars</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Job Applications</span>
                        <div className="text_mini">
                          <p>50</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Money-back Guarantee</span>
                        <div className="text_mini">
                          <p>30 days</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="btn_blk">
                        <a className="site_btn" href="/subscription">
                          Select Plan
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              <>
                <div className="col">
                  <ul className="title_sub_lst">
                    <li>
                      <h4 className="color">Free</h4>
                    </li>
                    <li>
                      <div className="gray_check_img">
                        <span>Visa-sponsored Jobs</span>
                        <div className="text_mini">
                          <p>30 jobs (first 2 pages)</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Community</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>CV Review</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Priority Support</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa Guidance</span>
                        <div className="text_mini">
                          <p>Basic</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Interview Prep</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Employer Network</span>
                        <div className="text_mini">
                          <p>Limited</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Success Rate</span>
                        <div className="text_mini">
                          <p>45%</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Monthly Webinars</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Job Applications</span>
                        <div className="text_mini">
                          <p>10</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Money-back Guarantee</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/cross-icon.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="btn_blk">
                        <a className="site_btn blank" href="/subscription">
                          Current Plan
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="col">
                  <ul className="title_sub_lst">
                    <li>
                      <h6>Explore</h6>
                      <h4 className="color">
                        £5.99 <small>/month</small>
                      </h4>
                      <p>Forever</p>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa-sponsored Jobs</span>
                        <div className="text_mini">
                          <p>All</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Community</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>CV Review</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                          <p>Unlimited</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Priority Support</span>
                        <div className="text_mini">
                          <p>24/7</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa Guidance</span>
                        <div className="text_mini">
                          <p>Expert</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Interview Prep</span>
                        <div className="text_mini">
                          <p>1-on-1</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Employer Network</span>
                        <div className="text_mini">
                          <p>VIP Access</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Success Rate</span>
                        <div className="text_mini">
                          <p>90%</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Monthly Webinars</span>
                        <div className="text_mini">
                          <p>Weekly</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Job Applications</span>
                        <div className="text_mini">
                          <p>Unlimited</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Money-back Guarantee</span>
                        <div className="text_mini">
                          <p>60 days</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="btn_blk">
                        <a className="site_btn" href="/subscription">
                          Select Plan
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="col">
                  <div className="top_most">
                    <p>Most Popular</p>
                  </div>
                  <ul className="title_sub_lst">
                    <li>
                      <h6>Achieve</h6>
                      <h4 className="color">
                        £9.99 <small>/month</small>
                      </h4>
                      <p>Forever</p>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa-sponsored Jobs</span>
                        <div className="text_mini">
                          <p>All</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Community</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>CV Review</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Priority Support</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Visa Guidance</span>
                        <div className="text_mini">
                          <p>Premium</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Interview Prep</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Employer Network</span>
                        <div className="text_mini">
                          <p>Full Access</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Success Rate</span>
                        <div className="text_mini">
                          <p>75%</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Monthly Webinars</span>
                        <div className="text_mini">
                          <img
                            src="/images/new/tick-circle.svg"
                            alt="not included"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Job Applications</span>
                        <div className="text_mini">
                          <p>50</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="gray_check_img">
                        <span>Money-back Guarantee</span>
                        <div className="text_mini">
                          <p>30 days</p>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="btn_blk">
                        <a className="site_btn" href="/subscription">
                          Select Plan
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            )} */}
          </div>
        </div>
      </section>
    </>
  );
};

export default SubscriptionPlanNew;
